import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';

type Props = {
  className?: string;
  children: ReactNode;
};

export const Card = (props: Props) => {
  return <Wrapper className={cx('man-ui card', props.className)}>{props.children}</Wrapper>;
};

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  background-color: #222;
`;
